import { IconButton, Button, makeStyles, Tooltip } from "@material-ui/core";
import { SvgIconComponent } from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  button: {
    padding: 3,
    textTransform: "none",
    color: theme.palette.secondary.contrastText,
  },
}));

type AppBarLinkButtonProps = {
  to: string;
  title: string;
  Icon: SvgIconComponent;
  dataTest: string;
};

export const AppBarLinkButton: React.FC<AppBarLinkButtonProps> = ({
  to,
  title,
  Icon,
  dataTest,
}) => {
  const classes = useStyles();
  return (
    <Tooltip title={title}>
      <Link to={to} data-test={dataTest}>
        <Button
          startIcon={<Icon style={{ color: "#fff" }}/>}
          className={classes.button}
        >
          {title}
        </Button>
      </Link>
    </Tooltip>
  );
};
